
import { Vue, Component, Prop } from "vue-property-decorator";
import * as echarts from "echarts";
enum mapData {
  "非常推荐" = 0,
  "推荐" = 1,
  "一般" = 2,
  "不推荐" = 3
}

@Component({})
export default class TableChars extends Vue {
  @Prop({ type: Number, default: 364 }) width!: number;
  @Prop({ type: Number, default: 130 }) height!: number;
  @Prop({ type: Array, default: [1, 1, 1, 1] }) listData!: number[]; //按照顺序 非常推荐，推荐， 一般， 不推荐传参
  private chartInstance!: echarts.ECharts;
  mounted() {
    this.initChart();
  }
  option = {
    title: {
      // text: "饼状图示例",
      // subtext: "纯属虚构",
      // left: "center"
    },
    tooltip: {
      trigger: "item",
      // formatter: '{b} <br/> {c} ({d}%)',
      formatter: (params: any) => {
        const color = params.color; // 获取系列颜色
        const indicator =
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
          color +
          ';"></span>';
        return (
          indicator +
          params.data.name +
          "<br/>" +
          params.value +
          "    (" +
          params.percent +
          "%" +
          ")"
        );
      }
    },
    legend: {
      orient: "vertical",
      left: "144px",
      align: "left",
      itemHeight: "8",
      itemWidth: 8,
      itemGap: 4,
      padding: 0,
      selectedMode: false,
      width: "188px",
      height: "100px",
      top: "12px",
      icon: "circle",
      formatter: (name: string) => {
        return `{a|${name}}{b|${this.listData[mapData[name]]}}`;
      },
      textStyle: {
        lineHeight: 22,
        rich: {
          a: {
            color: "#1C1C1C",
            fontsize: 12,
            width: 48,
            height: 22,
            marginTop: 4
          },
          b: {
            textAlign: "right",
            padding: [0, 0, 0, 30],
            width: 53,
            height: 22
          }
        }
      }
    },
    series: [
      {
        type: "pie",
        left: "8px",
        width: "120px",
        top: "5px",
        height: "120px",
        radius: "100%",
        bottom: "0px",
        data: [
          { value: this.listData[mapData["非常推荐"]], name: "非常推荐" },
          { value: this.listData[mapData["推荐"]], name: "推荐" },
          { value: this.listData[mapData["一般"]], name: "一般" },
          { value: this.listData[mapData["不推荐"]], name: "不推荐" }
        ],
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 1,
          emphasis: {
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)"
          }
        },
        selectedOffset: 1,
        labelLine: {
          show: false
        },
        label: {
          show: false
        },
        color: ["#4DC369", "#62C7FF", "#C6C7F8", "#FE9F00"]
      }
    ]
  };
  private initChart() {
    // 基于准备好的dom，初始化echarts实例
    this.chartInstance = echarts.init(
      this.$refs.chart as HTMLDivElement,
      undefined,
      {
        renderer: "svg"
      }
    );
    this.chartInstance.on("click", params => {
      this.$emit("earchsClick", params);
    });
    // this.chartInstance.setOption(this.option);
  }

  // 提供更新图表的方法
  public updateOption() {
    this.option.series[0].data = [
      {
        value: this.listData[mapData["非常推荐"]],
        name: "非常推荐"
      },
      { value: this.listData[mapData["推荐"]], name: "推荐" },
      { value: this.listData[mapData["一般"]], name: "一般" },
      { value: this.listData[mapData["不推荐"]], name: "不推荐" }
    ];
    this.option.series[0].itemStyle.borderWidth =
      this.listData.filter(el => el !== 0).length !== 1 ? 1 : 0;
    this.chartInstance.setOption(this.option);
  }
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
}
